import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface RoleBasedRouteProps {
  children: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Only jobizzness@sellox.io can access customers page
  if (location.pathname === '/customers') {
    if (currentUser.email !== 'jobizzness@sellox.io') {
      return <Navigate to="/" />;
    }
  }

  // All authenticated users can access pins and products pages
  return <>{children}</>;
};

export default RoleBasedRoute;
